import { IconButton } from "@mui/material";
import { CloseIcon } from "../../shared/icons";
import theme from "../../app/app-theme";

interface FormCloseButtonProps {
    onClose: () => void
}

const FormCloseButton = ({ onClose }: FormCloseButtonProps) => {
    return (
        <IconButton aria-label="close" onClick={onClose} sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            ":hover": {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText
            }
        }}>
            <CloseIcon />
        </IconButton>
    );
}

export default FormCloseButton;